import cloneDeep from 'lodash/cloneDeep'
import { ProspectForm } from './types'

interface ProspectPayload {
  values: Partial<{ id: string[] } & Omit<ProspectForm, 'id'>>
}

export const createProspectForm = ({
  prospect,
  prospectId,
  defaultForm,
}: {
  defaultForm: boolean
  prospect: ProspectForm
  prospectId?: string
}) => {
  const prospectForm: ProspectPayload = { values: {} }
  if (prospectId) {
    prospectForm.values.id = [prospectId]
  }
  const keys = Object.keys(prospect)
  keys.forEach(key => {
    if (key !== 'name' || !defaultForm) {
      if (prospect[key]) {
        prospectForm.values[key] = Array.isArray(prospect[key])
          ? prospect[key]
          : [prospect[key].toString().trim()]
      }
    }
  })
  return prospectForm
}

export const parseProspectName = (prospect: ProspectForm, defaultForm: boolean) => {
  if (prospect.name === undefined) {
    return cloneDeep(prospect)
  }
  if (defaultForm) {
    const [firstName, lastName] = prospect.name.replace(/\s+/g, ' ').trim().split(' ')
    return {
      ...prospect,
      firstname: firstName,
      lastname: lastName ?? prospect.firstname?.trim(),
    }
  } else {
    return {
      ...prospect,
      name: `${prospect.firstname ?? ''} ${prospect.lastname ?? ''}`,
    }
  }
}
